import { useEffect } from "react";
import { SITE, OG_IMAGE, PAGES, pageJsonld } from "@/seo.mjs";

const upsert = (selector, create, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
};
const meta = (key, value, attr = "name") =>
  upsert(`meta[${attr}="${key}"]`, () => document.createElement("meta"), { [attr]: key, content: value });

export const applySeo = ({ path, title, description, image = OG_IMAGE, jsonld = [], type = "website" }) => {
  const url = `${SITE}${path}`;
  document.title = title;
  meta("description", description);
  meta("og:title", title, "property");
  meta("og:description", description, "property");
  meta("og:url", url, "property");
  meta("og:image", image, "property");
  meta("og:type", type, "property");
  meta("twitter:title", title);
  meta("twitter:description", description);
  meta("twitter:image", image);
  upsert('link[rel="canonical"]', () => document.createElement("link"), { rel: "canonical", href: url });
  let s = document.getElementById("seo-jsonld");
  if (!s) { s = document.createElement("script"); s.id = "seo-jsonld"; s.type = "application/ld+json"; document.head.appendChild(s); }
  s.textContent = JSON.stringify(jsonld);
};

export const Seo = ({ page, data }) => {
  useEffect(() => {
    if (data) applySeo(data);
    else if (page) applySeo({ ...PAGES[page], jsonld: pageJsonld(page) });
  }, [page, data]);
  return null;
};
